module.exports = __webpack_public_path__ + "media/images/img/tag_company/tis_tag-de9a7e24972f66524deb44a2c3a6c3c9.png";